import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface MethodBucket {
  count: number
  amount: number
}

export interface MonthBreakdown {
  month: string // YYYY-MM
  cardcom: MethodBucket
  tranzila: MethodBucket
  bank_transfer: MethodBucket
  cheque: MethodBucket
  cash: MethodBucket
  refund: MethodBucket // all refunds/credit-notes (any method)
  card_refund: MethodBucket // subset of refunds that were on a card
  card_total: MethodBucket
  card_settlement: number // expected deposit from the credit-card company (card charges − card refunds)
  gross: number
  net: number
}

export interface BreakdownResponse {
  success: boolean
  from: string
  to: string
  duplicates_dropped: number
  months: MonthBreakdown[]
}

export interface InstallmentPlan {
  payments: number
  count: number
  amount: number
}

export interface InstallmentsResponse {
  success: boolean
  month: string
  coverage_note: string
  api_transactions_seen: number
  installment_deals: number
  installment_amount: number
  plans: InstallmentPlan[]
}

export function getPaymentBreakdown(params?: {from?: string; to?: string}): Promise<{data: BreakdownResponse}> {
  return adminApi.get(`${API_URL}/admin/payment-breakdown`, {params})
}

export function getInstallments(month: string): Promise<{data: InstallmentsResponse}> {
  return adminApi.get(`${API_URL}/admin/payment-breakdown/installments`, {params: {month}})
}

export interface ScheduleMonth {
  month: string
  payments: number
  amount: number
  deals: number
  carryover_payments: number
  carryover_amount: number
}

export interface ScheduleResponse {
  success: boolean
  current_month: string
  installment_deals: number
  note: string
  schedule: ScheduleMonth[]
}

export function getInstallmentSchedule(): Promise<{data: ScheduleResponse}> {
  return adminApi.get(`${API_URL}/admin/payment-breakdown/installment-schedule`)
}

export interface PayoutDate {
  date: string // YYYY-MM-DD
  regular: number
  installments: number
  total: number
  payments: number
  paid: boolean // credit date already passed
}

export interface PayoutForecastResponse {
  success: boolean
  fee_rate: number
  total_upcoming: number
  total_paid: number
  note: string
  forecast: PayoutDate[]
}

export function getPayoutForecast(): Promise<{data: PayoutForecastResponse}> {
  return adminApi.get(`${API_URL}/admin/payment-breakdown/payout-forecast`)
}
